(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => initializeProductGallery());
  
    function initializeProductGallery() {
      const mainSlider = document.querySelector('#main-slider');
      const thumbnailSlider = document.querySelector('#thumbnail-slider');
  
      if (!mainSlider) return;
  
      // Clean up existing instances to prevent memory leaks
      if (window.splideInstances) {
        const existingMain = window.splideInstances.get('main-slider');
        const existingThumbnails = window.splideInstances.get('thumbnail-slider');
  
        if (existingMain && !existingMain.state.is.destroyed) {
          existingMain.destroy();
        }
        if (existingThumbnails && !existingThumbnails.state.is.destroyed) {
          existingThumbnails.destroy();
        }
      }
  
      // Initialize main slider
      const main = new Splide('#main-slider', {
        type: 'slide',
        pagination: false,
        arrows: true,
        rewind: true,
        lazyLoad: 'nearby',
        keyboard: 'global',
        drag: true,
        focus: 'center',
        trimSpace: false,
        breakpoints: {
          1024: {
            pagination: true,
          },
        },
      });
  
      // Initialize thumbnail slider if exists
      let thumbnails = null;
      if (thumbnailSlider) {
        thumbnails = new Splide('#thumbnail-slider', {
          direction: 'ttb',
          height: '40rem',
          perPage: 5,
          gap: 5,
          rewind: true,
          pagination: false,
          isNavigation: true,
          arrows: true,
          waitForTransition: true,
          lazyLoad: 'nearby',
          keyboard: false,
          drag: true,
          focus: 'center',
        });
  
        main.sync(thumbnails);
      }
  
      // Mount sliders
      main.mount();
      if (thumbnails) {
        thumbnails.mount();
      }
  
      // Video control functionality
      let currentActiveVideo = null;
  
      function handleVideoControl() {
        const activeSlide = mainSlider.querySelector('.splide__slide.is-active');
        const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
  
        // Pause previous active video
        if (currentActiveVideo && currentActiveVideo !== activeVideo) {
          currentActiveVideo.pause();
        }
  
        // Play new active video if exists
        if (activeVideo) {
          activeVideo.play().catch((error) => {
            console.log('Video autoplay failed:', error);
          });
        }
  
        // Update current active video reference
        currentActiveVideo = activeVideo;
      }
  
      // Handle video control on slide change
      main.on('moved', handleVideoControl);
      main.on('mounted', handleVideoControl);
  
      // Store instances for cleanup
      if (!window.splideInstances) {
        window.splideInstances = new Map();
      }
      window.splideInstances.set('main-slider', main);
      if (thumbnails) {
        window.splideInstances.set('thumbnail-slider', thumbnails);
      }
    }
  
    // Make function globally available
    window.initializeProductGallery = initializeProductGallery;
  } catch(e) { console.error(e); }
})();

})();
